export const orderHeadingList = [
  'Make',
  'Model',
  'Trim/Type',
  'Model Year',
  'VIN Number',
  'Registration number',
  'ODO',
  'Exterior Colour',
  'Interior Colour',
  'Engine CC',
  'Gears',
  'Reserved Price',
  'Buy now Price',
  // "No of times Vehicle is recycled",
  // "Status ( Sold/Available)",
  'Auction Start Date',
  'Auction End Date',
];

export const orderItemList = [
  'Make',
  'Model',
  'Trim/Type',
  'Model Year',
  'VIN Number',
  'Plate Number',
  'ODO',
  'Exterior Colour',
  'Interior Colour',
  'CC',
  'Gear',
  'Reserved Price',
  'Buy now Price',
  // "No of times Vehicle is recycled",
  // "Status ( Sold/Available)",
  'Auction start date',
  'Auction end date',
];

// For Inventory
export const inventoryOrderHeadingList = [
  'Make',
  'Model',
  'Trim/Type',
  'Model Year',
  'VIN Number',
  'Registration number',
  'Added In',
  'ODO',
  'Exterior Colour',
  'Interior Colour',
  'Engine CC',
  'Gears',
];

export const inventoryOrderItemList = [
  'Make',
  'Model',
  'Trim/Type',
  'Model Year',
  'VIN Number',
  'Plate Number',
  'Added In',
  'ODO',
  'Exterior Colour',
  'Interior Colour',
  'CC',
  'Gear',
];

// For Batch Detail
export const batchOrderHeadingList = [
  'Make',
  'Model',
  'Trim/Type',
  'Model Year',
  'VIN Number',
  'Registration number',
  'ODO',
  'Exterior Colour',
  'Interior Colour',
  'Engine CC',
  'Gears',
  'Reserved Price',
  'Buy now Price',
  'No of times Vehicle is recycled',
  'Status (Sold/Available)',
  'Accleration',
  'COD',
  'Condition',
  'Cylinders',
  'Doors',
  'Estimara',
];

export const batchOrderItemList = [
  'Make',
  'Model',
  'Trim/Type',
  'Model Year',
  'VIN Number',
  'Plate Number',
  'ODO',
  'Exterior Colour',
  'Interior Colour',
  'CC',
  'Gear',
  'Reserved Price',
  'Buy now Price',
  'No of times Vehicle is recycled',
  'Status (Sold/Available)',
  'Accleration',
  'COD',
  'Condition',
  'Cylinders',
  'Doors',
  'Estimara',
];

export const auctionUser = {
  email_username: 'auction.user@gmail.com',
  password: '8Zte1gW!U0TLEjPpDA*8AN!Ot',
};

export const productCategory = [
  { id: 1, name: 'Buy Use', value: 2 },
  { id: 2, name: 'Buy New', value: 3 },
];

export const productStatus = [
  { id: 1, name: 'Pending', value: null },
  { id: 2, name: 'Reserve', value: true },
  { id: 3, name: 'Unreserve', value: false },
  { id: 4, name: 'Sold', value: true },
  // { id: 5, name: "Reject", value: 2 },
];

export const purchaseStatus = [
  { id: 1, name: 'Approved', value: 'approved' },
  { id: 2, name: 'Rejected', value: 'rejected' },
];

export const individualWinner = ['Make', 'Model', 'Model Year', 'Plate Number'];

export const soldOrderHeadingList = [
  'Make',
  'Model',
  'Trim/Type',
  'Model Year',
  'Auction Type',
  'VIN Number',
  'Registration number',
  'ODO',
  'Exterior Colour',
  'Interior Colour',
  'Engine CC',
  'Gears',
  'Reserved Price',
  'Buy now Price',
  // "No of times Vehicle is recycled",
  // "Status ( Sold/Available)",
  'Auction Start Date',
  'Auction End Date',
];

export const soldOrderItemList = [
  'Make',
  'Model',
  'Trim/Type',
  'Model Year',
  'Entity Type',
  'VIN Number',
  'Plate Number',
  'ODO',
  'Exterior Colour',
  'Interior Colour',
  'CC',
  'Gear',
  'Reserved Price',
  'Buy now Price',
  // "No of times Vehicle is recycled",
  // "Status ( Sold/Available)",
  'Auction start date',
  'Auction end date',
];

export const validationCheck = {
  alphabetCheck: '[ a-zA-Z]*',
  numberCheckPattern: '^[0-9]*$',
  emailPattern: '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z0-9]{1,50}$',
};
